import gql from 'graphql-tag'

export const GET_STOCK = gql`
  query {
    stock {
      id
      isMain
      name
    }
  }
`

export const GET_STOCKS = gql`
  query(
    $page: Int 
    $perPage: Int
    $shopee: Boolean
    $lazada: Boolean
    $orderBy: StockOrderBy 
  ){
    stocks(
      page: $page, 
      perPage: $perPage
      orderBy: $orderBy
      filter: {
        shopee: $shopee
        lazada: $lazada
      }
    ) {
      hasNextPage
      nodes {
        id
        isMain
        name
      }
    }
  }
`
export const GET_SHIPPING_TYPES = gql`
query getShippingTypes($id: ID!) {
  stock(id: $id) {
    shop {
      shippingTypes
    }
  }
}
`
export const GET_STOCK_ADDRESS = gql`
  query(
    $page: Int 
    $perPage: Int
    $orderBy: StockOrderBy 
  ){
    stocks(
      page: $page, 
      perPage: $perPage
      orderBy: $orderBy
    ) {
      hasNextPage
      nodes {
        id
        name
        address
      }
    }
  }
`

export default {
  GET_STOCK,
  GET_STOCKS,
  GET_SHIPPING_TYPES,
  GET_STOCK_ADDRESS
}
